module.exports = __webpack_public_path__ + "img/img9.cb4cff57.png";